// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"38":"ed70a628","513":"f218ad9b","533":"847f94ca","954":"44f660cc"}[chunkId] + ".chunk.css";
};